// extracted by mini-css-extract-plugin
export default {"base":"EditGameVersion_base__e0tm7","label":"EditGameVersion_label__mDbJY","field":"EditGameVersion_field__qEPRN","select":"EditGameVersion_select__G1ybc"};